import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import {
  ResponseStatusCodeFunction,
  cmsTransport,
  cmsTransportWithLogoutHandler,
} from './transports';
import { TeacherUploadQuestionsAPIServiceV1 } from '@protos/content_management/cms.teacher.questions.apis_connect';

export const CMSTeacherUploadQuestionAPIServiceV1Client = createPromiseClient(
  TeacherUploadQuestionsAPIServiceV1,
  cmsTransport
);

export const useTeacherUploadQuestionAPIServiceV1ClientWithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    TeacherUploadQuestionsAPIServiceV1,
    cmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
